import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import help from "../assets/js/help";
export default {
  name: "AuthorImg",
  data: function data() {
    return {};
  },
  props: {
    headImg: {
      type: String,
      default: ""
    },
    userId: {
      type: [String, Number],
      default: ""
    },
    nickName: {
      type: [String, Number],
      default: "佚名"
    },
    userType: {
      type: [String, Number],
      default: ""
    },
    isTop: {
      type: [String, Number],
      default: 0
    },
    source: {
      type: [String, Number],
      default: "1"
    },
    tags: {
      type: [String],
      default: ""
    },
    level: {
      type: [String],
      default: ""
    },
    isClub: {
      type: Boolean,
      default: false
    },
    isCircleLandlord: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isD1ev: function isD1ev() {
      var source = this.source - 0;
      return source === 1 || source === 3;
    },
    authorImage: function authorImage() {
      var _source = this.source;
      var _headImg = this.headImg;

      if (_headImg) {
        if (this.isD1ev && _headImg.indexOf("/d/file/") !== -1) {
          if (_headImg.indexOf("http") !== -1) {
            if (_headImg.indexOf("!") !== -1) {
              return _headImg;
            } else {
              return _headImg + "!144x144";
            }
          } else {
            return "https://cdn-fs.d1ev.com" + _headImg + "!88x88";
          }
        } else if ((_source === "2" || _source === 2) && _headImg.indexOf("http") === -1) {
          return "//cdz.evcharge.cc/zhannew/uploadfile/" + _headImg;
        } else {
          if (_headImg.indexOf("logo-d1ev-app") !== -1) {
            return "";
          } else {
            return _headImg;
          }
        }
      } else {
        return "";
      }
    },
    userTypeToString: function userTypeToString() {
      if (this.userType) {
        return this.userType.toString();
      }
    },
    checkedNickName: function checkedNickName() {
      if (/\d{11}/g.test(this.nickName)) {
        return help.resetPhoneNum(this.nickName);
      } else {
        return this.nickName;
      }
    }
  },
  methods: {
    onClickUser: function onClickUser() {
      var _source = this.source;
      var _userId = this.userId;

      if (_source && _userId && this.isD1ev) {
        window.location.href = "https://car-m.d1ev.com/circle/user/" + _userId;
      }
    }
  }
};